import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useRouterStore = defineStore('routerStore', () => {
  const previousPath = ref('')
  return {
    previousPath
  }
})
